import { request } from '@/api/http';
// import qs from 'qs'

export function login(data) {
  return request({
    url: '/api/v5/auth/signIn',
    method: 'post',
    data: data
  });
}
export function getCaptcha() {
  return request({
    url: 'api/v5/auth/captcha',
    method: 'get'
  }).then(function (response) {
    return response.data;
  });
}
export function refreshToken(data) {
  return request({
    url: '/api/v5/auth/refresh',
    method: 'post',
    data: data,
    noAuth: true,
    skipAuthRefresh: true
  });
}
export function logout(access_token) {
  return request({
    url: '/api/v5/auth/logout',
    method: 'post',
    data: {
      access_token: access_token
    }
  });
}
export function getInfo() {
  return request({
    url: '/api/v5/sys/user/info',
    method: 'get'
  });
}